import { Injectable, Inject } from '@angular/core';
import {LoopBackAuth} from "../../shared/sdk";
import {StorageBrowser} from "../../shared/sdk";

@Injectable()
export class AppAuthService extends LoopBackAuth {

  constructor(
    @Inject(StorageBrowser) public override storage: StorageBrowser
  ) {
    super(storage);
  }


}
